module.exports = __webpack_public_path__ + "static/media/print.92f1af2f.jpeg";